<template>
  <div class="detail">
    <div class="detail-banner">
      <div class="container">
        <h1 v-if="product">{{ product.name }}</h1>
        <h1 v-else>产品详情</h1>
        <p v-if="product && product.summary" class="pd-banner-sub">{{ product.summary }}</p>
      </div>
    </div>
    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>
        <div class="detail-content" v-if="product">
          <!-- 主图（置顶） -->
          <div class="cover-wrap">
            <img v-if="product.cover" class="detail-cover" :src="product.cover" :alt="product.name" @error="onImgError" />
            <div v-else class="detail-cover cover-fallback">{{ product.name.slice(0, 1) }}</div>
          </div>

          <!-- 名称 / 标签 / 来源地（移到图片下方） -->
          <div class="pd-tags">
            <span class="pd-tag" v-if="product.typeName">{{ product.typeName }}</span>
            <span class="pd-tag" v-if="product.secondTypeName">{{ product.secondTypeName }}</span>
            <span class="pd-tag" v-if="product.thirdTypeName">{{ product.thirdTypeName }}</span>
          </div>
          <div class="pd-source" v-if="product.sourcePlace">
            <span class="pd-source-label">来源地</span>
            <span class="pd-source-value">{{ product.sourcePlace }}</span>
          </div>

          <!-- 详细介绍（唯一正文） -->
          <div class="pd-section">
            <div class="pd-section-title">详细介绍</div>
            <div class="rich" v-html="product.content"></div>
          </div>

          <button class="btn-primary pd-consult" @click="consult">立即咨询</button>
        </div>
        <div class="detail-content" v-else-if="!loading">
          未找到该产品。
        </div>
        <div class="detail-content" v-else>加载中…</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchProductDetail } from '../api/home'
import { WECHAT_WORK_CONSULT_URL } from '../config/site'

export default {
  name: 'ProductDetail',
  props: ['id'],
  data () {
    return {
      product: null,
      loading: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.product = await fetchProductDetail(this.id)
      } catch (e) {
        this.product = null
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    onImgError (e) {
      e.target.style.display = 'none'
    },
    consult () {
      window.open(WECHAT_WORK_CONSULT_URL, '_blank', 'noopener')
    }
  }
}
</script>

<style scoped>
.detail-body {
  padding: 0 0 50px;
}
.detail-cover {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 14px;
  display: block;
}
.cover-wrap {
  background: linear-gradient(135deg, var(--primary-light), var(--primary));
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 26px;
}
.cover-fallback {
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 64px;
  font-weight: 800;
}
/* 标签：加大间距，避免“靠太近” */
.pd-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.pd-tag {
  background: var(--blue-soft);
  color: var(--primary);
  font-size: 13.5px;
  font-weight: 700;
  padding: 7px 16px;
  border-radius: 20px;
}
.pd-source {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: var(--blue-soft-2);
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-bottom: 28px;
}
.pd-source-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--primary);
}
.pd-source-value {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-main);
}
.pd-section {
  border-top: 1px solid var(--border);
  padding-top: 24px;
}
.pd-section-title {
  font-size: 18px;
  font-weight: 800;
  color: var(--primary);
  margin-bottom: 16px;
  position: relative;
  padding-left: 14px;
}
.pd-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  width: 4px;
  border-radius: 3px;
  background: linear-gradient(180deg, var(--primary-light), var(--primary));
}
.rich {
  line-height: 1.9;
  color: #33415c;
  font-size: 15px;
}
.rich ::v-deep p {
  margin: 0 0 12px;
}
.pd-consult {
  display: block;
  width: fit-content;
  margin: 30px auto 0;
}
/* 蓝色 banner 内简介：与自营服务详情页 .os-banner-sub 同款白字样式 */
.pd-banner-sub {
  margin: 8px 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.6;
}
.btn-primary {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 12px 34px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.25s ease;
}
.btn-primary:hover {
  background: var(--primary-dark);
}
</style>
